module.exports = __webpack_public_path__ + "img/quaR.4209b84a.png";